import React from "react";

export const RefreshIcon = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.29636 5.49243C7.75441 3.105 11.6826 3.12582 14.1137 5.55688C16.5669 8.01007 16.5669 11.9884 14.1137 14.4417C11.6605 16.8949 7.68219 16.8949 5.22897 14.4417C4.985 14.1976 4.98493 13.8009 5.22897 13.5569C5.47302 13.3129 5.86969 13.3129 6.11374 13.5569C8.0788 15.5219 11.2639 15.5219 13.229 13.5569C15.1939 11.5918 15.194 8.40668 13.229 6.44165C11.2869 4.49973 8.15398 4.47782 6.18405 6.37427H7.17136C7.51646 6.37427 7.79624 6.65419 7.79636 6.99927C7.79636 7.34445 7.51653 7.62427 7.17136 7.62427H4.04636V4.49927C4.04647 4.15419 4.32625 3.87427 4.67136 3.87427C5.01646 3.87427 5.29624 4.15419 5.29636 4.49927V5.49243Z"
                  fill="black"/>
        </svg>
    );
}